const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {ErrorBoundary} = require("react-error-boundary");
const _ = require("lodash");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const styles = require("./styles/ReviewCart.css");

const loadjs = require("loadjs");
let domready = require("domready");
if (process.env.IS_NODE) {
	domready = () => {};
}

// TODO: weird to have initialization code like this here.
let ThirdPartyPaypalButton = null;
let paypalLoadErrored = false;
let paypalLoadCbs = [];
domready(function() {
	ThirdPartyPaypalButton = _.get(global, "paypal.Button.react");
	if (ThirdPartyPaypalButton) {
		return;
	}

	global.React = React;
	global.ReactDOM = require("react-dom");
	loadjs("https://www.paypalobjects.com/api/checkout.js", {
		success: () => {
			ThirdPartyPaypalButton = _.get(global, "paypal.Button.react");
			paypalLoadErrored = !ThirdPartyPaypalButton;
			paypalLoadCbs.forEach(f => f());
			paypalLoadCbs = null;
		},
		error: () => {
			paypalLoadErrored = true;
			paypalLoadCbs.forEach(f => f());
			paypalLoadCbs = null;
		},
		before: (path, el) => {
			el.setAttribute("data-version-4", "");
			el.setAttribute("data-log-level", "error");
		},
	});
});

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "PaypalButton",

		propTypes: {
			paymentID: PT.string,
			text: PT.string.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			startPaypalComplete: function() {
				if (!this.paypalResolve) {
					// ew
				} else {
					this.paypalResolve(this.props.paymentID);
				}
			},
			startPaypalFail: function(error) {
				if (this.paypalReject) {
					this.paypalReject(error);
				}
			},
		},

		componentDidMount: function() {
			if (!ThirdPartyPaypalButton && !paypalLoadErrored) {
				paypalLoadCbs.push(() => {
					if (!this.unmounted) {
						this.forceUpdate();
					}
				});
			}
		},

		componentWillUnmount: function() {
			this.unmounted = true;
		},

		onAuthorize: function(data, actions) {
			actions.payment.get().then(paymentData => {
				const payerInfo = paymentData.payer.payer_info;
				const shippingInfo = payerInfo.shipping_address;

				const actionData = {
					type: AT.SET_PAYPAL_MODAL_DATA,
					paymentID: data.paymentID,
					payerID: data.payerID,
					contactVals: {
						email: payerInfo.email,
					},
				};

				// Only set shippingInfo if needed
				if (shippingInfo) {
					actionData.shippingVals = {
						name: shippingInfo.recipient_name,
						country: shippingInfo.country_code,
						address1: shippingInfo.line1 || "",
						address2: shippingInfo.line2 || "",
						city: shippingInfo.city,
						state: shippingInfo.state,
						zipcode: shippingInfo.postal_code,
					};
				}

				this.props.dispatch(actionData);
			});

			// In Edge, paypal's lightbox wants to stick around and eat all mouse events.
			if (global.document) {
				setTimeout(
					() =>
						_.each(document.querySelectorAll("iframe"), el => {
							if (el.parentNode && /lightbox/.test(el.getAttribute("name"))) {
								el.parentNode.removeChild(el);
							}
						}),
					2000
				);
			}
		},

		render: function() {
			if (paypalLoadErrored) {
				// Best to silently fail here.
				return null;
			} else if (!ThirdPartyPaypalButton) {
				return null;
			}

			// For some reason React got upset at trying to make this a class method.
			const payment = (resolve, reject) => {
				this.paypalResolve = resolve;
				this.paypalReject = reject;
				this.props.dispatch({
					type: AT.START_PAYPAL_REQUEST,
				});
			};

			return (
				<ErrorBoundary
					onError={() => {
						paypalLoadErrored = true;
						this.forceUpdate();
					}}
					fallbackRender={() => null}
				>
					<div className={styles.paypal}>
						<div className={styles.paypalText}>{this.props.text}</div>
						<ThirdPartyPaypalButton
							env={
								process.env.NODE_ENV === "production" ? "production" : "sandbox"
							}
							payment={payment}
							onAuthorize={this.onAuthorize}
							style={{label: "generic", tagline: false}}
						/>
					</div>
				</ErrorBoundary>
			);
		},
	})
);
